$(() => {
  $(document).ready(() => {
    const container = $("#dashboard");
    if(!container) return;

    const url = document.location.toString();
    if (url.match('#')) {
      console.log("Hash found");
      $('.nav-card-tabs a').removeClass("active");
      $('.nav-card-tabs a[href="#'+url.split('#')[1]+'"]').tab('show').addClass("active");
    }

    $('.nav-card-tabs a').on('shown.bs.tab', function (e) {
      console.log("Change tab");
      if(history.pushState) {
        history.pushState(null, null, e.target.hash);
      } else {
        window.location.hash = e.target.hash;
      }
    })
  })
})
